<div class="bg-white rounded-xl border-[1px] border-gray-300 py-4 px-4 overflow-visible">
  <!-- Header -->
  <div class="flex justify-between items-center mb-0 pb-[14px] border-b border-gray-200">
    <div *ngIf="isEdit" class="w-2"></div>
    <!-- EMPTY DIV THAT TAKE THE SPACE OF THE EXTERNAL HANDLER-->

    <!-- title dropdown in edit mode -->
    <ng-container *ngIf="isEdit && alternativeTitle !== ''; else defaultTitle">
      <div class="relative">

        <!-- transparent overlay for dropdown to close it when clicking outside -->
        <div
          *ngIf="titleDropdownOpen"
          class="fixed inset-0 z-40"
          (click)="closeTitleDropdown()"
        ></div>

        <!-- dropdown trigger button -->
        <button
          type="button"
          (click)="toggleTitleDropdown()"
          class="relative z-50 flex items-center justify-between gap-3 min-w-[180px] xl:min-w-[240px]
                 px-3 py-1 rounded-md border bg-white cursor-pointer transition-colors duration-200
                 text-[#002b5b] text-[0.56rem] xl:text-[0.68rem] 2xl:text-[0.86rem]
                 hover:bg-[#f4f7fb]"
          [ngClass]="titleDropdownOpen ? 'border-[#002b5b] shadow-sm' : 'border-gray-300'"
        >
          <span class="truncate">
            {{ displayedTitle }}
          </span>
          <svg
            class="w-3 h-3 shrink-0 transition-transform duration-200"
            [class.rotate-180]="titleDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- dropdown  -->
        <ul
          *ngIf="titleDropdownOpen"
          class="absolute left-0 top-full mt-1 w-full z-50 overflow-hidden
                 bg-white border border-[#002b5b] rounded-md shadow-lg"
        >
          <li
            (click)="selectTitleOption('first')"
            class="px-3 py-1.5 cursor-pointer text-[#002b5b] text-[0.56rem] xl:text-[0.68rem] 2xl:text-[0.86rem]
                   hover:bg-[#f4f7fb] truncate"
            [ngClass]="{ 'bg-[#e6eef7] font-semibold': selectedTitleOption === 'first' }"
          >
            {{ title }}
          </li>
          <li
            (click)="selectTitleOption('second')"
            class="px-3 py-1.5 cursor-pointer border-t border-gray-100 text-[#002b5b] text-[0.56rem] xl:text-[0.68rem] 2xl:text-[0.86rem]
                   hover:bg-[#f4f7fb] truncate"
            [ngClass]="{ 'bg-[#e6eef7] font-semibold': selectedTitleOption === 'second' }"
          >
            {{ alternativeTitle }}
          </li>
        </ul>
      </div>
    </ng-container>

    <!-- default title -->
    <ng-template #defaultTitle>
      <h3
        class="text-[#002b5b]
               text-[0.58rem]
               xl:text-[0.75rem]
               2xl:text-[0.88rem]"
        [ngClass]="{
          'text-[0.56rem] xl:text-[0.68rem] 2xl:text-[0.86rem] pt-[2px]': isEdit,
          'relative left-17':
            (className === 'widget-evolution-regional-access' || className === 'widget-evolution-regional-market') && isEdit
        }"
      >
        {{ displayedTitle }}
      </h3>
    </ng-template>
    <!--<button
      type="button"
      class="text-[#002b5b] hover:text-white hover:bg-dimot-1 text-2xl border-1 border-dimot-1 w-[22px] h-[22px] items-center justify-center flex cursor-pointer"
      *ngIf="!isEdit && className === 'widget-attivita'"
      (click)="openModalAddActivity()"
    > + </button>-->
    <div class="flex flex-row gap-1">
      <!-- LEGEND EVOLUZIONE WIDGET -->
     <ng-container *ngIf="(className === 'widget-evolution-regional-access') || (className === 'widget-evolution-regional-market') || (className === 'widget-evolution-regional-economia') || (className === 'widget-evolution-regional-market-30-days') || (className === 'widget-curva-accesso') || (className === 'widget-curva-economia') || (className === 'widget-curva-mercato') || (className === 'widget-curva-mercato-30-giorni') || (className === 'widget-curva-mercato-30-giorni-merged')">
      <div class="flex flex-row gap-1">
        <div class="flex items-center gap-7 font-sans w-full justify-end relative right-8"> 
          <div class="flex items-center gap-1.5"> <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] bg-dimot-2 rounded-sm">
          </span> 
          <h2 class="text-[0.5rem] xl:text-[0.6rem] text-gray-500">Forecast</h2> </div> <div class="flex items-center gap-1.5"> 
            <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] rounded-sm bg-dimot-1"></span>
             <h2 class="text-[0.5rem] xl:text-[0.6rem] text-gray-500">Actual</h2> 
            </div>
           </div>
      </div>
     </ng-container>
<!-- BUTTON MERGE HEATMAP OSPEDALIERA -->
<ng-container *ngIf="(className === 'widget-heatmap') && !isEdit">
   <button
    type="button"
    class="group flex items-center justify-center relative right-[2px] 2xl:right-3
           w-[24px] h-[18px] xl:w-[28px] xl:h-[20px] 2xl:w-[38px] 2xl:h-[22px]
           rounded-md border border-[#002b5b]
           text-[#002b5b]
           hover:bg-[#002b5b] hover:text-white
           cursor-pointer transition-colors duration-200"
    title="Merge heatmap"
(click)="mergedHeatmapStatusChange(true)"
  >
    <svg
      viewBox="0 0 32 16"
      xmlns="http://www.w3.org/2000/svg"
      class="w-[14px] h-[9px] xl:w-[17px] xl:h-[10px] 2xl:w-[24px] 2xl:h-[14px]"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <!-- freccia sinistra verso il centro -->
      <path d="M2 8H10" />
      <path d="M6 4L10 8L6 12" />

      <!-- lineetta centrale -->
      <path d="M16 3V13" />

      <!-- freccia destra verso il centro -->
      <path d="M30 8H22" />
      <path d="M26 4L22 8L26 12" />
    </svg>
  </button>
</ng-container>
                 <!-- HEATMAP APERTURA OSPEDALIERA TOGGLE -->
          <ng-container *ngIf="(className === 'widget-heatmap') && !isEdit">
<div class="flex items-center relative left-[5px] 2xl:left-0">
  <!-- Toggle -->
  <label
    class="relative inline-flex items-center cursor-pointer select-none
           w-[24px] h-[13px] xl:w-[28px] xl:h-[15px] 2xl:w-[34px] 2xl:h-[17px]"
  >
    <input 
      type="checkbox" 
      class="sr-only peer" 
      [checked]="heatmapColor === 'White'"
      (change)="onToggleHeatmapHospitalsChange($event)"
    />

    <!-- Track -->
    <span
      class="absolute inset-x-[2px] top-1/2 -translate-y-1/2 rounded-full
             h-[9px] xl:h-[10px] 2xl:h-[11px]
             bg-[#fbe5e6] peer-checked:bg-[#e0e2e9]
             transition-colors duration-150"
    ></span>

    <!-- Knob -->
    <span
      class="absolute left-0 top-1/2 -translate-y-1/2 rounded-full
             w-[13px] h-[13px] xl:w-[15px] xl:h-[15px] 2xl:w-[17px] 2xl:h-[17px]
             bg-white
             box-border border-[0.8px] xl:border-[1px] 2xl:border-[1.35px] border-dimot-1
             transition-[left] duration-150 ease-out
             peer-checked:left-[calc(100%-13px)]
             xl:peer-checked:left-[calc(100%-15px)]
             2xl:peer-checked:left-[calc(100%-17px)]
             peer-focus-visible:ring-2 peer-focus-visible:ring-dimot-1/25"
    ></span>
  </label>

</div>
     </ng-container>
     <!-- HEATMAP INCLUSIONE REGIONALE TOGGLE-->
      <ng-container *ngIf="(className === 'widget-mapOpenAccess') && !isEdit">
        <div class="flex items-center">
  <!-- Toggle -->
  <label
    class="relative inline-flex items-center cursor-pointer select-none
           w-[24px] h-[13px] xl:w-[28px] xl:h-[15px] 2xl:w-[34px] 2xl:h-[17px]"
  >
    <input 
      type="checkbox" 
      class="sr-only peer" 
      [checked]="heatmapRegionalInclusionColor === 'White'"
      (change)="onToggleHeatmapRegionalInclusionChange($event)"
    />

    <!-- Track -->
    <span
      class="absolute inset-x-[2px] top-1/2 -translate-y-1/2 rounded-full
             h-[9px] xl:h-[10px] 2xl:h-[11px]
             bg-[#fbe5e6] peer-checked:bg-[#e0e2e9]
             transition-colors duration-150"
    ></span>

    <!-- Knob -->
    <span
      class="absolute left-0 top-1/2 -translate-y-1/2 rounded-full
             w-[13px] h-[13px] xl:w-[15px] xl:h-[15px] 2xl:w-[17px] 2xl:h-[17px]
             bg-white
             box-border border-[0.8px] xl:border-[1px] 2xl:border-[1.35px] border-dimot-1
             transition-[left] duration-150 ease-out
             peer-checked:left-[calc(100%-13px)]
             xl:peer-checked:left-[calc(100%-15px)]
             2xl:peer-checked:left-[calc(100%-17px)]
             peer-focus-visible:ring-2 peer-focus-visible:ring-dimot-1/25"
    ></span>
  </label>
  </div>
        </ng-container>

<!-- BUTTON MERGE HEATMAP ECONOMIA -->
<ng-container *ngIf="(className === 'widget-heatmap-economia') && !isEdit">
   <button
    type="button"
    class="group flex items-center justify-center relative right-[2px] 2xl:right-3
           w-[24px] h-[18px] xl:w-[28px] xl:h-[20px] 2xl:w-[38px] 2xl:h-[22px]
           rounded-md border border-[#002b5b]
           text-[#002b5b]
           hover:bg-[#002b5b] hover:text-white
           cursor-pointer transition-colors duration-200"
    title="Merge heatmap"
(click)="mergedHeatmapEconomiaStatusChange(true)"
  >
    <svg
      viewBox="0 0 32 16"
      xmlns="http://www.w3.org/2000/svg"
      class="w-[14px] h-[9px] xl:w-[17px] xl:h-[10px] 2xl:w-[24px] 2xl:h-[14px]"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <!-- freccia sinistra verso il centro -->
      <path d="M2 8H10" />
      <path d="M6 4L10 8L6 12" />

      <!-- lineetta centrale -->
      <path d="M16 3V13" />

      <!-- freccia destra verso il centro -->
      <path d="M30 8H22" />
      <path d="M26 4L22 8L26 12" />
    </svg>
  </button>
</ng-container>



        <!-- HEATMAP ECONOMIA TOGGLE -->
<ng-container *ngIf="(className === 'widget-heatmap-economia') && !isEdit">
  <div class="flex items-center relative left-[5px] 2xl:left-0">
  <!-- Toggle -->
  <label
    class="relative inline-flex items-center cursor-pointer select-none
           w-[24px] h-[13px] xl:w-[28px] xl:h-[15px] 2xl:w-[34px] 2xl:h-[17px]"
  >
    <input 
      type="checkbox" 
      class="sr-only peer" 
      [checked]="heatmapEconomiaColor === 'White'"
      (change)="onToggleHeatmapEconomiaChange($event)"
    />

    <!-- Track -->
    <span
      class="absolute inset-x-[2px] top-1/2 -translate-y-1/2 rounded-full
             h-[9px] xl:h-[10px] 2xl:h-[11px]
             bg-[#fbe5e6] peer-checked:bg-[#e0e2e9]
             transition-colors duration-150"
    ></span>

    <!-- Knob -->
    <span
      class="absolute left-0 top-1/2 -translate-y-1/2 rounded-full
             w-[13px] h-[13px] xl:w-[15px] xl:h-[15px] 2xl:w-[17px] 2xl:h-[17px]
             bg-white
             box-border border-[0.8px] xl:border-[1px] 2xl:border-[1.35px] border-dimot-1
             transition-[left] duration-150 ease-out
             peer-checked:left-[calc(100%-13px)]
             xl:peer-checked:left-[calc(100%-15px)]
             2xl:peer-checked:left-[calc(100%-17px)]
             peer-focus-visible:ring-2 peer-focus-visible:ring-dimot-1/25"
    ></span>
  </label>
  </div>
</ng-container>
      <!---->
<!-- HOSPITALS AND EXPERIENCES EXCEL -->

<button (click)="generateHospitalsReport()" *ngIf="className === 'widget-nHospitalsAndExperiences' && !isEdit" type="button"
class="group rounded-md border px-2 relative left-2 2xl:left-0 h-[17px] w-[54px] 2xl:w-[74px] 2xl:h-[22px] flex items-center justify-center 2xl:justify-between bg-[#0A768A] border-[#0A768A] text-white hover:bg-white hover:text-[#0A768A] cursor-pointer" >
<h5 class="text-[0.5rem] 2xl:text-[0.64rem] mr-1 2xl:mr-0"> Report </h5> 
<svg width="13" height="13" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="shrink-0 w-[10px] h-[10px] 2xl:w-[13px] 2xl:h-[13px] fill-white group-hover:fill-[#0A768A]" >
    <path d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.875 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z"/>
  </svg>
</button>
<!-- CURVE REPORT -->
<button
  (click)="hasCurveDataToShowReportButton && generateReport(true)"
  *ngIf="(className === 'widget-curva-accesso' || className === 'widget-curva-mercato' || className === 'widget-curva-economia') && !isEdit"
  [disabled]="!hasCurveDataToShowReportButton"
  type="button"
  class="group rounded-md border px-2 w-[62px] h-[22px] 2xl:w-[74px] 2xl:h-[22px] flex items-center justify-between"
  [ngClass]="{
    'bg-[#0A768A] border-[#0A768A] text-white hover:bg-white hover:text-[#0A768A] cursor-pointer': hasCurveDataToShowReportButton,
    'bg-gray-300 border-gray-300 text-gray-100 cursor-not-allowed': !hasCurveDataToShowReportButton
  }"
>
  <h5 class="text-[0.5rem] 2xl:text-[0.64rem]">Report</h5>

  <svg
    width="13"
    height="13"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    class="shrink-0 w-[11px] h-[11px] 2xl:w-[13px] 2xl:h-[13px]"
    [ngClass]="{
      'fill-white group-hover:fill-[#0A768A]': hasCurveDataToShowReportButton,
      'fill-current': !hasCurveDataToShowReportButton
    }"
  >
    <path d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.875 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z"/>
  </svg>
</button>
      <button 
      #tooltipButton
       (click)="toggleTooltip()"
      type="button" class="relative group text-[#002b5b] pl-[9px]" *ngIf="!isEdit">
        <svg fill="#141e58" width="18" height="18" 
        class="w-[15px] h-[15px] xl:w-[18px] xl:h-[18px]"
        viewBox="-6.5 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="m8.436.006c.051-.004.111-.007.172-.007 1.237 0 2.239 1.003 2.239 2.239 0 .041-.001.081-.003.122v-.006c-.079 1.679-1.46 3.01-3.151 3.01-.022 0-.043 0-.065-.001h.003c-.069.008-.15.012-.231.012-1.188 0-2.151-.963-2.151-2.151 0-.088.005-.174.015-.259l-.001.01c.063-1.655 1.419-2.972 3.084-2.972.031 0 .062 0 .093.001h-.005zm-4.947 23.994c-1.268 0-2.199-.783-1.311-4.226l1.456-6.108c.254-.978.295-1.369 0-1.369-1.141.293-2.142.752-3.035 1.359l.033-.021-.633-1.057c3.086-2.622 6.638-4.159 8.158-4.159 1.268 0 1.48 1.526.845 3.874l-1.666 6.421c-.296 1.135-.168 1.526.126 1.526 1.106-.256 2.069-.761 2.863-1.456l-.008.007.72.979c-3.004 3.052-6.281 4.232-7.549 4.232z">
            </path>
          </g>
        </svg>

        <div
          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 text-white bg-[#002b5b] rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-normal break-words text-[0.56rem] xl:text-[0.58rem] 2xl:text-[0.7rem] 3xl:text-[0.72rem] text-center z-50 pointer-events-none"
            [ngClass]="[
    getTooltipWidthClass(),
    tooltipVisible ? 'opacity-100 visible' : ''
  ]">
          {{ tooltipInfo?.text }}
          <div
            class="absolute top-full left-[calc(50%+5px)] -translate-x-1/2 border-4 border-transparent border-t-[#002b5b]">
          </div>
        </div>

      </button>
      
   <!-- This version open the modal
    <button class="text-[#002b5b] cursor-pointer" *ngIf="isEdit" (click)="openModalDelete(true)">
        <img src="../../../../../assets/img/Icons/close-lg-svgrepo-com.svg" width="20" height="20" />
      </button>  --> 
      <button class="text-[#002b5b] cursor-pointer" *ngIf="isEdit" (click)="onDelete()">
        <img src="../../../../../assets/img/Icons/close-lg-svgrepo-com.svg"
         width="20" height="20"
         class="w-[12px] h-[12px] xl:w-[17px] xl:h-[17px]"
         />
      </button> 
    </div>
  </div>
  <!-- HERE IS WHERE WE WILL LOAD THE WIDGET INSTEAD OF IMGs -->
  <div *ngIf="className == 'widget-esperienze-map'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">


    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/esperienzeMap.png"
      width="380"
    />-->
    <app-potential-per-region-map></app-potential-per-region-map>
  </div>
  <div *ngIf="className == 'widget-heatmap'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-heatmap-inclusion-process
   [heatmapColorStatus]="heatmapColor"
    ></app-heatmap-inclusion-process>
  </div>

 <div *ngIf="className == 'widget-heatmap-economia'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">
  <app-heatmap-economia
    [heatmapColorStatus]="heatmapEconomiaColor"
    (economiaDataLoaded)="onEconomiaDataLoaded($event)"
  ></app-heatmap-economia>
</div>


  <div *ngIf="className == 'widget-map-forecast-complete-access'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">


    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/esperienzeMap.png"
      width="380"
    />-->
    <app-map-forecast-complete-access></app-map-forecast-complete-access>
  </div>

  <div *ngIf="className == 'widget-mapOpenAccess'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">

    <app-map-open-to-access-regions
    [heatmapColorStatus]="heatmapRegionalInclusionColor"
    ></app-map-open-to-access-regions>
  </div>

  <div *ngIf="className == 'widget-map-forecast-complete-access'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">


    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/esperienzeMap.png"
      width="380"
    />-->
    <app-map-forecast-complete-access></app-map-forecast-complete-access>
  </div>


<div class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[420px] relative overflow-y-auto" *ngIf="className == 'widget-attivita'">
  <app-regional-access-activity-plan-table
    (openModalAddActivities)="openModalAddActivity(true)"
  ></app-regional-access-activity-plan-table>
</div>
  <div class="mt-4 pl-7 xl:pl-0 w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[320px] xl:h-[350px] 2xl:h-[420px]" *ngIf="className == 'widget-curva-accesso'">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiAccesso - Copia.png"
      width="600"
    />-->

    <app-open-to-access-curve 
    class="block h-full w-full relative top-2"
      (hasOpenToAccessCurveData)="checkIfCurveHasData($event)"
    [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'">
      ></app-open-to-access-curve>
  </div>

  <!-- CURVA ECONOMIA --> 
   <div *ngIf="className == 'widget-curva-economia'" class="mt-4 pl-7 xl:pl-0 w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[320px] xl:h-[350px] 2xl:h-[420px]" >

    <app-open-to-economia-curve 
    class="block h-full w-full relative top-2"
      (hasOpenToEconomiaCurveData)="checkIfCurveHasData($event)"
    [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'">
      ></app-open-to-economia-curve>
  </div>
   <!-- CURVA DI APERTURA OSPEDALIERA -->
  <div *ngIf="className == 'widget-curva-mercato'" class="mt-4 pl-7 xl:pl-0 w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[320px] xl:h-[350px] 2xl:h-[420px]">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-open-to-market-curve 
    class="block h-full w-full relative top-2"
    (hasOpenToMarketCurveData)="checkIfCurveHasData($event)"
    [widgetTitle]="displayedTitle"
    [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'"></app-open-to-market-curve>
  </div>

  <!-- CURVA DI APERTURA OSPEDALIERA 30 GIORNI -->
  <div *ngIf="className == 'widget-curva-mercato-30-giorni'" class="mt-4 pl-7 xl:pl-0 w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[400px] xl:h-[430px] 2xl:h-[500px]">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-open-to-market-curve-30-days 
    class="block h-full w-full relative top-2"
      (hasOpenToMarketCurveData)="checkIfCurveHasData($event)"
    [widgetTitle]="displayedTitle"
    [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'">
      ></app-open-to-market-curve-30-days>
  </div>

    <!-- CURVA DI APERTURA OSPEDALIERA 30 GIORNI MERGED -->
  <div *ngIf="className == 'widget-curva-mercato-30-giorni-merged'" class="mt-4 pl-7 xl:pl-0 w-[868px] xl:w-[1040px] 2xl:w-[1284px] h-[400px] xl:h-[430px] 2xl:h-[500px]">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-open-to-market-curve-30-days-merged 
    class="block h-full w-full relative top-2"
    (hasOpenToMarketCurveData)="checkIfCurveHasData($event)"
    [widgetTitle]="displayedTitle"
    [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'">
      </app-open-to-market-curve-30-days-merged>
  </div>

<!-- EVOLUTION REGIONAL ACCESS -->
  <div *ngIf="className == 'widget-evolution-regional-access'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] mt-4"
      [ngClass]="{
    'h-[100px] 2xl:h-[165px]': !isEvoluzioneTwoRowsLayout,
    'h-[180px] 2xl:h-[282px]': isEvoluzioneTwoRowsLayout
  }"
    >
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-evolution-regional-access
    (isTwoRowLayout)="isEvoluzioneTwoRowsLayout = $event">
    </app-evolution-regional-access>
  </div>

  <!-- EVOLUTION REGIONAL ECONOMIA -->
  <div *ngIf="className == 'widget-evolution-regional-economia'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] mt-4"
      [ngClass]="{
    'h-[100px] 2xl:h-[165px]': !isEvoluzioneTwoRowsLayout,
    'h-[180px] 2xl:h-[282px]': isEvoluzioneTwoRowsLayout
  }"
    >
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-evolution-regional-economia
    (isTwoRowLayout)="isEvoluzioneTwoRowsLayout = $event">
    </app-evolution-regional-economia>
  </div>

  <!-- EVOLUTION REGIONAL MARKET -->
  <div *ngIf="className == 'widget-evolution-regional-market'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] mt-4"
      [ngClass]="{
    'h-[100px] 2xl:h-[165px]': !isEvoluzioneTwoRowsLayout,
    'h-[180px] 2xl:h-[282px]': isEvoluzioneTwoRowsLayout
  }"
    >
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-evolution-regional-market
    (isTwoRowLayout)="isEvoluzioneTwoRowsLayout = $event">
    </app-evolution-regional-market>
  </div>

    <!-- EVOLUTION REGIONAL MARKET 30 DAYS-->
  <div *ngIf="className == 'widget-evolution-regional-market-30-days'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] mt-4"
      [ngClass]="{
    'h-[100px] 2xl:h-[165px]': !isEvoluzioneTwoRowsLayout,
    'h-[180px] 2xl:h-[282px]': isEvoluzioneTwoRowsLayout
  }"
    >
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-evolution-regional-market-30-days
    (isTwoRowLayout)="isEvoluzioneTwoRowsLayout = $event">
    </app-evolution-regional-market-30-days>
  </div>


   <!-- Inclusion Process Tool National -->
  <div *ngIf="className == 'widget-inclusion-process-tool-national'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1284px] mt-4 h-[220px] xl:h-[260px] 2xl:h-[250px]">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-inclusion-process-tool-national>
    </app-inclusion-process-tool-national>
  </div>

  <div *ngIf="className == 'widget-monitoringForecastVsActualRegionalLevel'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4" 
>
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-monitoring-forecast-vs-actual-regional-level></app-monitoring-forecast-vs-actual-regional-level>
  </div>

  <div *ngIf="className == 'widget-forecastTimeProgress'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-nt-forecast-time-progress></app-nt-forecast-time-progress>
  </div>

  <div *ngIf="className == 'widget-nHospitalsAndExperiences'"  class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] my-2">

    <!-- vertical 
       <div *ngIf="className == 'widget-nHospitalsAndExperiences'" class="w-96 mt-4"
    [ngClass]="{ '2xl:w-[720px] 2xl:h-[350px]': extendWidget }">
    -->

    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-n-hospitals-and-experiences></app-n-hospitals-and-experiences>
  </div>

  <div *ngIf="className == 'widget-monitoringCompleteAccess'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-monitoring-complete-access></app-monitoring-complete-access>
  </div>

    <div *ngIf="className == 'widget-monitoringAggiudicazione'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-monitoring-aggiudicazione></app-monitoring-aggiudicazione>
  </div>

  <div *ngIf="className == 'widget-forecast-accuracy-openToAccess'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-forecast-accuracy-open-to-access></app-forecast-accuracy-open-to-access>
  </div>

   <div *ngIf="className == 'widget-forecast-accuracy-openToEconomia'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-forecast-accuracy-open-to-economia></app-forecast-accuracy-open-to-economia>
  </div>

   <div *ngIf="className == 'widget-forecast-accuracy-openToMarket'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mb-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-forecast-accuracy-open-to-market></app-forecast-accuracy-open-to-market>
  </div>

</div>

<!-- Delete modal -->
<!--<div *ngIf="deleteModalOpen"
  class="fixed inset-0 isolate z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-xs p-4">
  <div class="relative bg-white rounded-lg p-6 max-w-md w-full">
    <button (click)="openModalDelete(false)"
      class="absolute top-2 right-4 text-gray-500 hover:text-black cursor-pointer">
      ✕
    </button>

    <div class="z-[999] flex flex-col items-center justify-center text-center gap-6 py-4">
      <img src="../../../../../assets/img/Icons/delete-widget.svg" width="60" height="60" class="mx-auto" />
      <span class="text-gray-700">Sei sicuro di voler nascondere questo widget?</span>
      <button (click)="onDelete()"
        class="bg-dimot-3 w-34 h-10 hover:bg-gray-700 text-[1em] 2xl:text-xs text-white rounded-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
        Elimina
      </button>
    </div>
  </div>
</div> -->

<app-loading-generation *ngIf="generateExcel" [widgetName]="className"></app-loading-generation>

<app-generate-excel *ngIf="canGenerateExcel" [widgetName]="className"
  (sendEndMessage)="onEndMessage($event)"></app-generate-excel>

  <app-generate-hospitals-and-experiences-excel *ngIf="generateHospitalsExcel"
  (exportComplete)="onEndHospitalsMessage()"></app-generate-hospitals-and-experiences-excel>


<app-merged-heatmap *ngIf="isMergedHeatmapEconomiaVisible"
  [heatmapColorStatus]="heatmapEconomiaColor"
  [dataMerged]="mergedHeatmapData"
  (closeModal)="mergedHeatmapEconomiaStatusChange($event)"
></app-merged-heatmap>

<app-customizable-heatmap-open-to-market *ngIf="isMergedHeatmapVisible"
[titleCardInCustom]="displayedTitle"
 [medicineInfoDataInCustom]="medicineInfoData"
  [widgetsAvailableInCustom]="widgetsAvailable"
  [heatmapColorStatus]="heatmapColor"
  (closeModal)="mergedHeatmapStatusChange($event)"
  ></app-customizable-heatmap-open-to-market>